function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#4D4D4D",
  d: "M10.1,1L15,6v11H1V1H10.1 M10.6,0H0v18h16V5.6L10.6,0L10.6,0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#4D4D4D",
  points: "15,6.5 9.5,6.5 9.5,1 10.5,1 10.5,5.5 15,5.5  "
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4D4D4D",
  d: "M7.7,15.2c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.8,0.7-0.8c0.4,0,0.7,0.3,0.7,0.8C8.5,14.9,8.2,15.2,7.7,15.2z  M8.3,13.2h-1l0-0.4c-0.1-0.6,0.2-1.2,0.6-1.8c0.4-0.5,0.7-0.9,0.7-1.3c0-0.5-0.3-0.7-0.8-0.7C7.4,8.9,7,9,6.8,9.2L6.6,9.3L6.3,8.4 l0.1-0.1C6.7,8.1,7.3,8,7.9,8c1.2,0,1.8,0.8,1.8,1.6c0,0.7-0.4,1.2-0.9,1.8c-0.4,0.5-0.6,0.9-0.5,1.4L8.3,13.2z"
});

var SvgFilesListingUntitled = function SvgFilesListingUntitled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    fill: "#434546",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: "new 0 0 16 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingUntitled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_untitled.000660c1.svg";
export { ForwardRef as ReactComponent };